export const API_URL = process.env.REACT_APP_API_URL;

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
    return `${API_URL}${endpoint}`;
};

// Add a test function to verify configuration
export const testApiConfig = () => {
    console.log('API_URL:', API_URL);
    console.log('Test endpoint:', buildApiUrl('/auth/login'));
    console.log('Environment:', process.env.NODE_ENV);
    
    if (!API_URL) {
        console.error('API_URL is not defined! Check your environment variables.');
        return false;
    }
    return true;
};
